var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconUniversity = function SvgIconUniversity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.962,
    height: 27.965,
    viewBox: "0 0 29.962 27.965",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-university",
    "data-name": "Icon awesome-university",
    d: "M31.087,8.242v1a.5.5,0,0,1-.5.5h-1.5v.749a.749.749,0,0,1-.749.749H3.872a.749.749,0,0,1-.749-.749V9.741h-1.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.308-.461L15.915,2.288a.5.5,0,0,1,.382,0L30.779,7.781A.5.5,0,0,1,31.087,8.242Zm-1.5,18.976H2.623a1.5,1.5,0,0,0-1.5,1.5v1a.5.5,0,0,0,.5.5H30.588a.5.5,0,0,0,.5-.5v-1A1.5,1.5,0,0,0,29.589,27.219ZM6.119,12.237V24.222H3.872a.749.749,0,0,0-.749.749V26.22H29.09V24.972a.749.749,0,0,0-.749-.749H26.094V12.237H22.1V24.222H18.1V12.237H14.109V24.222H10.114V12.237Z",
    transform: "translate(-1.125 -2.25)",
    fill: "#f6c866"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconUniversity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-university.cade2a93.svg";
export { ForwardRef as ReactComponent };